import { Dispatch } from 'redux';
import KlaviyoController from '../controllers/KlaviyoController';
import { klaviyoErrorHandler } from '../errorHandlers/klaviyo-handler';
import { KlaviyoListsResponse } from '../model/KlaviyoModel';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';

class KlaviyoCRUDActions extends CrudActionContainer {
  retrieveLists: string;
  revokeAction: string;

  constructor() {
    super('KLAVIYO');
    this.retrieveLists = this.makeActionKey('RETRIEVED_LISTS');
    this.revokeAction = this.makeActionKey('REVOKE');
  }

  revoke(webhookId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.revokeAction));

      try {
        await KlaviyoController.revokeToken(webhookId);
        dispatch(this.unbusy());
        return true;
      } catch (error) {
        klaviyoErrorHandler(dispatch)(error, this.revokeAction);
        return false;
      }
    };
  }

  getLists(webhookId: number, force: boolean = false) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveLists));
      try {
        const response: KlaviyoListsResponse = await KlaviyoController.getLists(
          webhookId,
          force,
        );
        dispatch({
          type: this.retrieveLists,
          lists: response,
        });
        return response;
      } catch (error) {
        klaviyoErrorHandler(dispatch)(error, this.retrieveLists);
      }
    };
  }
}

const klaviyoCRUDActions = new KlaviyoCRUDActions();

export default klaviyoCRUDActions;

export const useKlaviyoCRUDActions = getActionHookBuilder(klaviyoCRUDActions, [
  'getLists',
  'revoke',
]);
